module.exports = __webpack_public_path__ + "aa55e07fc2319ff382fd293b5fd2d10d.svg";